/**
 * Initial state factory for the "subscribe" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. `following`/`followers` hold
 * the currently loaded connection lists, while `followingCount`/`followersCount`
 * hold the total counts reported by the API (independent of how many items
 * have been loaded into the arrays).
 */
export default () => ({
    following: [],
    followers: [],

    followingCount: 0,
    followersCount: 0,
});
